var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8FlcheRduire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23.978516 11.5 A 1.50015 1.50015 0 0 0 22.939453 11.939453 L 3.4394531 31.439453 A 1.50015 1.50015 0 1 0 5.5605469 33.560547 L 24 15.121094 L 42.439453 33.560547 A 1.50015 1.50015 0 1 0 44.560547 31.439453 L 25.060547 11.939453 A 1.50015 1.50015 0 0 0 23.978516 11.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FlcheRduire);
export default __webpack_public_path__ + "static/media/icons8-flèche-réduire.32ef3ff25810bb5f8576391d6b20feab.svg";
export { ForwardRef as ReactComponent };